import { render, staticRenderFns } from "./Attendee.vue?vue&type=template&id=f8be90fe&"
import script from "./Attendee.vue?vue&type=script&lang=js&"
export * from "./Attendee.vue?vue&type=script&lang=js&"
import style0 from "./Attendee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports